import { Property } from '../interfaces';
import { toast } from 'react-toastify';

export const firstLetterToUpper = (word: string) => {
  return word[0].toUpperCase() + word.slice(1);
}

export const formatAddress = (property: Property) => {
  let format = '';
  if (property.district) {
    format = property.district + ', ';
  }
  return `${format}${property.city}, ${property.zip}, ${property.country}`;
}

export const formatCurrency = (amount: number = 0, currency = 'EUR') => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: currency || 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export const formatStatus = (word: string = '') => {
  return word.split(' ').map(firstLetterToUpper).join(' ');
}

export const enumToArray = (object: Object) => {
  return Object.values(object)
    .filter((v, i, self) => self.indexOf(v) === i);
}

export const handleServerError = (reason: any) => {
  console.error(reason);
  const message = reason?.data?.message || reason?.error?.data?.message || reason?.error;
  if (Array.isArray(message)) {
    message.forEach((msg: string) => {
      toast.error(msg);
    });
  } else {
    toast.error(message);
  }
}

export const objectToString = (object: Record<string, any>) => {
  return Object.keys(object)
    .filter(key => !!object[key])
    .map(key => key + '=' + object[key])
    .join('&');
}

export const stringToObject = (string: string) => {
  const object: Record<string, any> = {};

  string.split('&')
    .forEach(pair => {
      const [key, value] = pair.split('=');
      object[key] = value;
    });

  return object;
}